const USER_DOCUMENT_TYPES = [
  {
    text: 'IRS',
    value: 1,
  },
  {
    text: 'Payroll',
    value: 2,
  },
  {
    text: 'A3',
    value: 3,
  },
  {
    text: 'Tax Clearance Certificate',
    value: 4,
  },
  {
    text: 'Two Year Published Balance Sheet',
    value: 5,
  },
  {
    text: 'E3',
    value: 6,
  },
  {
    text: 'E5',
    value: 7,
  },
  {
    text: 'Two Year Certified Balance Sheet',
    value: 8,
  },
  {
    text: 'Certified Balance Sheet',
    value: 9,
  },
  {
    text: 'Public Utility Bill',
    value: 10,
  },
  {
    text: 'Periodic Vat Declarations',
    value: 11,
  },
  {
    text: 'Form N',
    value: 12,
  },
  {
    text: 'Vehicle Specs Sheet',
    value: 13,
  },
  {
    text: 'Invoice',
    value: 14,
  },
  {
    text: 'Driver Licence',
    value: 15,
  },
  {
    text: 'Personal Identification',
    value: 16,
  },
  {
    text: 'Other',
    value: 27,
  },
];

export { USER_DOCUMENT_TYPES };
